module.exports = __webpack_public_path__ + "img/icon-event-list-place.f4ba2243.svg";